import { render, staticRenderFns } from "./BackupServer.vue?vue&type=template&id=08580a9e&scoped=true&"
import script from "./BackupServer.vue?vue&type=script&lang=js&"
export * from "./BackupServer.vue?vue&type=script&lang=js&"
import style0 from "./BackupServer.vue?vue&type=style&index=0&id=08580a9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08580a9e",
  null
  
)

export default component.exports